import AttachmentPreferencesOptionState from '../store/schema/AttachmentPreferencesOptionState';
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import OwaViewStateConfiguration from 'owa-service/lib/contract/OwaViewStateConfiguration';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import AttachmentPreferencesChoiceGroup from './AttachmentPreferencesChoiceGroup';

export interface AttachmentPreferencesFullProps {
    optionStore?: AttachmentPreferencesOptionState;
    userOptions?: OwaViewStateConfiguration;
}

@reactive({
    optionStore: () => store,
    userOptions: () => getUserConfiguration().ViewStateConfiguration,
})
export default class AttachmentPreferencesFull extends React.Component<
    AttachmentPreferencesFullProps,
    {}
> {
    render() {
        let { optionStore, userOptions } = this.props;
        let fromOneDriveSelectedKey = getFallbackValueIfNull(
            optionStore.fromOneDrive,
            userOptions.AttachOrShareCloudFiles
        );

        return (
            <div>
                <AttachmentPreferencesChoiceGroup
                    selectedKey={fromOneDriveSelectedKey}
                    label={strings.options_attachmentPreferences_cloudLabel}
                    optionKey="fromOneDrive"
                />
            </div>
        );
    }
}
